

export const SOFTLINE_API_MDE_MATERIALLIEFERSCHEIN_SCAN = "/v1/materiallieferscheinScan";
export const SOFTLINE_API_MDE_MATERIALLIEFERSCHEIN_SCAN_ABSCHLUSS = "/v1/materiallieferscheinScan/{{idkopflf}}/abschluss";
export const SOFTLINE_API_MDE_MATERIALLIEFERSCHEIN_SCAN_BEWE = "/v1/materiallieferscheinScan/{{idkopflf}}/bewegung/entities";
export const SOFTLINE_API_MDE_MATERIALLIEFERSCHEIN_SCAN_ARTIKEL_DETAIL = "/v1/materiallieferscheinScan/artikel/entities";

export const SOFTLINE_API_MDE_MATERIALLIEFERSCHEIN_SCAN_BARCODE = "/v1/materiallieferscheinScan/matlf/scan/{{code}}";
export const SOFTLINE_API_MDE_MATERIALLIEFERSCHEIN_SCAN_EINLESEN = "/v1/materiallieferscheinScan/{{idkopflf}}/einlesen";
